// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListSearchWithin";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss, searchBoxFieldClickableStyles, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        ${xScreen("gte", "lg")} {
            border: 1px solid ${color("common.border")};
            border-radius: 0 0 4px 4px;
            padding: 0 9px;
        }
        div:empty {
            display: none;
        }
    `,
};

searchWithinStyles.titleText = {
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        width: 100%;
        ${xScreen("gte", "lg")} {
            padding-top: 10px;
        }
        display: inline-block;
    `,
};

searchWithinStyles.searchTagsContainer = {
    css: css`
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        > div:last-child:has(> div:empty) {
            display: none;
        }
    `,
};

searchWithinStyles.searchTextField = {
    sizeVariant: "default",
    ...mergeWithCss(searchBoxFieldClickableStyles, {
        cssOverrides: {
            formInputWrapper: css`
                &&&& input {
                    padding-right: 50px;
                }
            `,
        },
    }),
};
